<template>
  <div class="audio__wrap">
    <audio
      controls
      :src="src"
      ref="audioPlayer"
      style="display:none"
      @play="$emit('play')"
      @pause="isPlaying = false"
      @ended="isPlaying = false"
    />
    <div class="self__audio">
      <div
        class="audio__trigger"
        @click="playAudioHandler"
        :class="{
          'position-left': symbolPosition === 'left',
          'position-right': symbolPosition === 'right',
        }"
      >
        <div class="audio__duration">{{ v_duration }}</div>
        <div
          :class="{
            'wifi-symbol': true,
            'wifi-symbol--avtive': isPlaying,
          }"
        >
          <div class="wifi-circle first"></div>
          <div class="wifi-circle second"></div>
          <div class="wifi-circle third"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return { isPlaying: false }
  },
  props: {
    src: { type: String, required: true },
    duration: { type: Number, default: 0 },
    symbolPosition: { type: String, default: 'left' },
  },
  computed: {
    v_duration() {
      if (!this.duration) return '0"'
      const minutes = Math.floor(this.duration / 60)
      const remainingSeconds = this.duration % 60
      if (!minutes) return `${remainingSeconds}"`
      return `${minutes}'${remainingSeconds}"`
    },
  },
  methods: {
    playAudioHandler() {
      this.isPlaying = !this.isPlaying
      const player = this.$refs.audioPlayer
      if (this.isPlaying) {
        player.load()
        player.play()
      } else {
        player.pause()
      }
    },
    pause() {
      const player = this.$refs.audioPlayer
      player.pause()
    },
  },
}
</script>
<style lang="scss" scoped>
.audio__wrap {
  .self__audio {
    .audio__trigger {
      cursor: pointer;
      vertical-align: top;
      display: inline-block;
      width: 100px;
      background-color: transparent;
      border-radius: 4px;
      height: 18px;
      display: flex;
      align-items: center;
      position: relative;
      .audio__duration {
        color: #888888;
        position: absolute;
        left: 10px;
        right: 30px;
        overflow: hidden;
      }
      .wifi-symbol {
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        overflow: hidden;
        transform: rotate(-45deg) scale(0.5);
        position: absolute;
        right: 0;
        .wifi-circle {
          border: 5px solid #999999;
          border-radius: 50%;
          position: absolute;
        }
        .first {
          width: 5px;
          height: 5px;
          background: #cccccc;
          top: 45px;
          left: 45px;
        }
        .second {
          width: 25px;
          height: 25px;
          top: 35px;
          left: 35px;
        }
        .third {
          width: 40px;
          height: 40px;
          top: 25px;
          left: 25px;
        }
      }
      .wifi-symbol--avtive {
        .second {
          animation: bounce 1s infinite 0.2s;
        }
        .third {
          animation: bounce 1s infinite 0.4s;
        }
      }
    }
    .audio__trigger.position-left {
      .audio__duration {
        left: 30px;
        right: 0;
      }
      .wifi-symbol {
        left: 0;
        right: initial;
        transform: rotate(135deg) scale(0.5);
      }
    }
    @keyframes bounce {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
}
</style>
